import { Button, cn, Stack } from '@landler/component-library';
import { TextInput } from 'component-library/TextInput/TextInput';
import { useTranslation } from 'react-i18next';

import { Icon } from '@/components/widgets/a/Icon/Icon';

export const SearchBar = ({
  searchQuery,
  setSearchQuery,
  placeholder,
  styles,
}: {
  searchQuery: string;
  setSearchQuery: (value: string) => void;
  placeholder?: string;
  styles?: {
    container?: string;
    icon?: string;
    input?: string;
    clearButton?: string;
  };
}) => {
  const { t } = useTranslation();
  return (
    <Stack
      className={cn(
        'flex h-11 flex-row gap-1 bg-neutral-black-4 border border-neutral-black-4 rounded-full justify-start px-3 py-1 items-center min-w-[150px]',
        styles?.container,
      )}
    >
      <Icon icon='ri-search-line' className={cn('text-md', styles?.icon)} />
      <TextInput
        placeholder={placeholder ?? t('shared.searchBar.placeholder')}
        className={cn(
          'w-full typography-body1 border-none bg-transparent h-full focus:border-none focus:outline-none focus-visible:outline-none px-0 py-0',
          styles?.input,
        )}
        value={searchQuery}
        onChange={(e) => setSearchQuery(e.target.value)}
      />
      {searchQuery && (
        <Button
          variant='text'
          className={cn('text-text-secondary hover:text-text-primary px-1 py-1', styles?.clearButton)}
          onClick={() => setSearchQuery('')}
        >
          <Icon icon='ri-close-line' className='text-sm' />
        </Button>
      )}
    </Stack>
  );
};
